import React, { useState, useEffect } from "react";
import { getAllCandidates, deleteResume, deleteCandidateResume, getAllProfilesWithPagination } from "../../Api/apiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { faArrowLeft, faEdit } from "@fortawesome/free-solid-svg-icons";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import "./ResumeList.css";
import Navbar from "../Navbar/Navbar";

const CandidateResumeList = () => {
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedResumeId, setSelectedResumeId] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    total: 0,
    per_page: 10,
    current_page: 0, // Start from 0 to match the backend
    total_pages: 0,
  });

  const getProfilesWithPagination = async (page, size, searchQuery =  "") => {
    try {
      const response = await getAllProfilesWithPagination(page, size, searchQuery);
      if (response?.status === 200 || response?.status === 201) {
        const activeProfiles = response.data.data.filter((profile) => !profile.isDeleted);
        setProfiles(activeProfiles); 
        setPagination({
          total: response.data.pagination.total,
          per_page: response.data.pagination.per_page,
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    getProfilesWithPagination(pagination.current_page, pagination.per_page, searchQuery);
  }, [pagination.current_page, searchQuery]);

  const handlePageChange = (page) => {
    if (page >= 0 && page < pagination.total_pages) {
      setPagination((prev) => ({ ...prev, current_page: page }));
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPagination((prev) => ({ ...prev, current_page: 0 })); // Reset to the first page
  };

  const handleViewClick = (userId) => {
    navigate(`/viewResumeCandidate/${userId}`);
  };

  const handleEdit = (userId) => {
    navigate(`/personalInfo/?candidateProfileId=${userId}`);
    window.localStorage.removeItem("profileId");
    window.localStorage.setItem("profileId", userId);
  };

  const openDeleteModal = (resumeId) => {
    setSelectedResumeId(resumeId);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedResumeId) return;
    try {
      console.log(selectedResumeId);
      const deleteResponse = await deleteCandidateResume(selectedResumeId);
      if (deleteResponse.data.isDeleted) {
        setProfiles((prevProfiles) =>
          prevProfiles.filter((profile) => profile.id !== selectedResumeId)
        );
        setShowDeleteModal(false);
        toast.success("Resume deleted successfully!", { autoClose: 1500 });
      }
    } catch (error) {
      toast.error("Failed to delete resume.");
    }
  };

  return (
    <>
      <Navbar />
      <Link to={"/dashboardHr"} className="icon-button" title="back">
        <FontAwesomeIcon className="employee-resume-list-back-btn" icon={faArrowLeft} />
      </Link>
      <div className="resume-list-table-container">
        <div className="resume-list-header">
        <h2 className="resume-list-table-heading">All Candidate Resumes</h2>
        
        <input
          type="text"
          className="search-input"
          placeholder="Search by Name or Email"
          value={searchQuery}
          onChange={handleSearch}
        />
        </div>
        <table className="resume-list-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {profiles.map((profile, index) => (
              <tr key={profile.id}>
                <td>{pagination.current_page * pagination.per_page + index + 1}</td>
                <td>{profile.name || "Unknown"}</td>
                <td>{profile.email || "Unknown"}</td>
                <td>
                  <button
                    className="resume-list-delete-button"
                    onClick={() => handleViewClick(profile.id)}
                  >
                    <FontAwesomeIcon className="resume-eye" icon={faEye} />
                  </button>
                  <button
                    className="resume-list-delete-button"
                    onClick={() => handleEdit(profile.id)}
                  >
                    <FontAwesomeIcon className="resume-eye" icon={faEdit} />
                  </button>
                  <button
                    className="resume-list-delete-button"
                    onClick={() => openDeleteModal(profile.id)}
                  >
                    <FontAwesomeIcon className="resume-eye" icon={faTrash} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="pagination-container">
          <button
            className="pagination-button"
            disabled={pagination.current_page === 0}
            onClick={() => handlePageChange(pagination.current_page - 1)}
          >
            Previous
          </button>
          {Array.from({ length: pagination.total_pages }, (_, index) => (
            <button
              key={index}
              className={`pagination-button ${
                pagination.current_page === index ? "active" : ""
              }`}
              onClick={() => handlePageChange(index)}
            >
              {index + 1}
            </button>
          ))}
          <button
            className="pagination-button"
            disabled={pagination.current_page === pagination.total_pages - 1}
            onClick={() => handlePageChange(pagination.current_page + 1)}
          >
            Next
          </button>
        </div>
      </div>

      <Modal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        height="150px"
        width="400px"
      >
        <p className="modal-heading">
          Are you sure you want to delete this resume?
        </p>
        <div className="modal-buttons">
          <Button onClick={confirmDelete}>Yes</Button>
          <Button onClick={() => setShowDeleteModal(false)}>No</Button>
        </div>
      </Modal>
    </>
  );
};

export default CandidateResumeList;